import { render, staticRenderFns } from "./MyActivity.vue?vue&type=template&id=faff89c6&scoped=true"
import script from "./MyActivity.vue?vue&type=script&lang=js"
export * from "./MyActivity.vue?vue&type=script&lang=js"
import style0 from "./MyActivity.vue?vue&type=style&index=0&id=faff89c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faff89c6",
  null
  
)

export default component.exports